import { Button } from '@unistocks/components/button/button';
import { DividerWithText } from '@unistocks/components/layout/divider';
import { Paragraph } from '@unistocks/components/text/text';
import { AuthFormProps } from '@unistocks/features/authentication/auth-form-props';
import { GoogleSignin } from '@unistocks/features/authentication/google/google-signin';
import { t } from '@unistocks/shared/localization/index.ts';
import { ExternalAuthenticationDto } from '@unistocks/types/auth';

export const ExternalLogin: React.FC<AuthFormProps<ExternalAuthenticationDto>> = ({
  isSubmitting,
  onSubmit,
  toggle
}) => (
  <>
    <GoogleSignin
      type={'login'}
      buttonText={t('AbpAccount::LogInUsingYourProviderAccount', { 0: 'Google' })}
      isLoading={isSubmitting}
      onLoginComplete={onSubmit}
    />

    <DividerWithText>
      <Paragraph>{t('::Or').toLowerCase()}</Paragraph>
    </DividerWithText>

    <Button theme={'unistocksAlt'} variant="outlined" onPress={toggle}>
      {t('AbpAccount::LogInUsingYourProviderAccount', {
        0: t('AbpAccount::Password').toLocaleLowerCase()
      })}
    </Button>
  </>
);

ExternalLogin.displayName = 'ExternalLogin';
